import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useSafetyStore } from '../../stores/safetyStore';
import { useDeviceStore } from '../../stores/deviceStore';
import { useUIStore } from '../../stores/uiStore';

export function SafetySettingsScreen() {
  const navigate = useNavigate();
  const { settings, manageSecurityDevices } = useSafetyStore();
  const { devices } = useDeviceStore();
  const { addToast } = useUIStore();

  const securityDevices = devices.filter(d => 
    settings?.deviceList?.some((sd: any) => sd.deviceId === d.deviceId)
  );

  const availableDevices = devices.filter(d => 
    !settings?.deviceList?.some((sd: any) => sd.deviceId === d.deviceId)
  );

  const handleToggleDevice = async (deviceId: string, isAdding: boolean) => {
    const currentIds = settings?.deviceList?.map((d: any) => d.deviceId) || [];
    const newIds = isAdding 
      ? [...currentIds, deviceId]
      : currentIds.filter((id: string) => id !== deviceId);
    
    await manageSecurityDevices(newIds);
    addToast(isAdding ? 'Датчик добавлен' : 'Датчик удален', 'success');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-4 py-4">
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate('/safety')}
              className="p-2 -ml-2 rounded-full hover:bg-gray-100"
            >
              <ArrowLeft className="w-6 h-6 text-gray-700" />
            </button>
            
            <h1 className="text-xl font-bold text-gray-900">Настройки охраны</h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-4 py-6">
        {/* Security Devices */}
        <div className="bg-white rounded-xl shadow-sm overflow-hidden mb-6">
          <div className="p-4 border-b border-gray-100">
            <h2 className="font-semibold text-gray-900">Датчики охраны</h2>
            <p className="text-sm text-gray-500">{securityDevices.length} устройств</p>
          </div>
          
          <div className="divide-y divide-gray-100">
            {securityDevices.length === 0 ? (
              <p className="p-4 text-center text-gray-500">Нет настроенных датчиков</p>
            ) : (
              securityDevices.map(device => (
                <div
                  key={device.deviceId}
                  className="flex items-center justify-between p-4"
                >
                  <div>
                    <p className="font-medium text-gray-900">{device.customName || device.baseName}</p>
                    <p className="text-sm text-gray-500">{device.room}</p>
                  </div>
                  
                  <button
                    onClick={() => handleToggleDevice(device.deviceId, false)}
                    className="text-red-500 text-sm hover:underline"
                  >
                    Удалить
                  </button>
                </div>
              ))
            )}
          </div>
        </div>

        {/* Available Devices */}
        <div className="bg-white rounded-xl shadow-sm overflow-hidden">
          <div className="p-4 border-b border-gray-100">
            <h2 className="font-semibold text-gray-900">Доступные устройства</h2>
          </div>
          
          <div className="divide-y divide-gray-100">
            {availableDevices.length === 0 ? (
              <p className="p-4 text-center text-gray-500">Нет доступных устройств</p>
            ) : (
              availableDevices.map(device => (
                <div
                  key={device.deviceId}
                  className="flex items-center justify-between p-4"
                >
                  <div>
                    <p className="font-medium text-gray-900">{device.customName || device.baseName}</p>
                    <p className="text-sm text-gray-500">{device.room}</p>
                  </div>
                  
                  <button
                    onClick={() => handleToggleDevice(device.deviceId, true)}
                    className="text-blue-500 text-sm hover:underline"
                  >
                    Добавить
                  </button>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
